import { createContext } from 'react'

import { Performance } from 'types'
import { State } from 'lib/hooks/useApi'

export type Context = State<Performance>

export const PerformanceContext = createContext({} as Context)
